import { apiClient } from '../../../api/client'
import type { RecordGroupOption } from '../types'

export async function getSelectableRecordGroups(): Promise<RecordGroupOption[]> {
  const { data } = await apiClient.get<RecordGroupOption[]>('/management/record-groups/selectable')
  return data
}
